/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignEditorialReviewerToActivity } from '../fn/editorial/assign-editorial-reviewer-to-activity';
import { AssignEditorialReviewerToActivity$Params } from '../fn/editorial/assign-editorial-reviewer-to-activity';
import { banEditorialUser } from '../fn/editorial/ban-editorial-user';
import { BanEditorialUser$Params } from '../fn/editorial/ban-editorial-user';
import { CompanyCategoriesResponsePaging } from '../models/company-categories-response-paging';
import { CompanyCategoryLanguagesResponse } from '../models/company-category-languages-response';
import { CompanyCategoryResponse } from '../models/company-category-response';
import { createCompanyCategory } from '../fn/editorial/create-company-category';
import { CreateCompanyCategory$Params } from '../fn/editorial/create-company-category';
import { createEditorialCompany } from '../fn/editorial/create-editorial-company';
import { CreateEditorialCompany$Params } from '../fn/editorial/create-editorial-company';
import { createEditorialCompanyDiscount } from '../fn/editorial/create-editorial-company-discount';
import { CreateEditorialCompanyDiscount$Params } from '../fn/editorial/create-editorial-company-discount';
import { createEditorialTags } from '../fn/editorial/create-editorial-tags';
import { CreateEditorialTags$Params } from '../fn/editorial/create-editorial-tags';
import { createPostCategory } from '../fn/editorial/create-post-category';
import { CreatePostCategory$Params } from '../fn/editorial/create-post-category';
import { deleteEditorialCompany } from '../fn/editorial/delete-editorial-company';
import { DeleteEditorialCompany$Params } from '../fn/editorial/delete-editorial-company';
import { deleteEditorialCompanyDiscount } from '../fn/editorial/delete-editorial-company-discount';
import { DeleteEditorialCompanyDiscount$Params } from '../fn/editorial/delete-editorial-company-discount';
import { deleteEditorialCouponRequest } from '../fn/editorial/delete-editorial-coupon-request';
import { DeleteEditorialCouponRequest$Params } from '../fn/editorial/delete-editorial-coupon-request';
import { deleteEditorialTag } from '../fn/editorial/delete-editorial-tag';
import { DeleteEditorialTag$Params } from '../fn/editorial/delete-editorial-tag';
import { deleteUserAdmin } from '../fn/editorial/delete-user-admin';
import { DeleteUserAdmin$Params } from '../fn/editorial/delete-user-admin';
import { EditorialActivityDetailResponse } from '../models/editorial-activity-detail-response';
import { EditorialActivityResponsePaging } from '../models/editorial-activity-response-paging';
import { EditorialAmbassadorGoldResponsePaging } from '../models/editorial-ambassador-gold-response-paging';
import { EditorialAmbassadorSilverResponsePaging } from '../models/editorial-ambassador-silver-response-paging';
import { EditorialAnalyticsDashboardCategoriesResponse } from '../models/editorial-analytics-dashboard-categories-response';
import { EditorialAnalyticsDashboardViewerResponse } from '../models/editorial-analytics-dashboard-viewer-response';
import { EditorialAnalyticsResumeResponse } from '../models/editorial-analytics-resume-response';
import { EditorialAnalyticsTrafficPerPostResponse } from '../models/editorial-analytics-traffic-per-post-response';
import { EditorialCompaniesResponsePaging } from '../models/editorial-companies-response-paging';
import { EditorialCompanyDiscountResponse } from '../models/editorial-company-discount-response';
import { EditorialCompanyDiscountResponsePaging } from '../models/editorial-company-discount-response-paging';
import { EditorialCompanyResponse } from '../models/editorial-company-response';
import { EditorialCouponResponse } from '../models/editorial-coupon-response';
import { EditorialCouponResponsePaging } from '../models/editorial-coupon-response-paging';
import { EditorialPostCategoryResponse } from '../models/editorial-post-category-response';
import { EditorialReviewerUser } from '../models/editorial-reviewer-user';
import { EditorialTagLanguagesResponse } from '../models/editorial-tag-languages-response';
import { EditorialTagResponse } from '../models/editorial-tag-response';
import { EditorialTagsPaginatedResponse } from '../models/editorial-tags-paginated-response';
import { EditorialTagsResponsePaging } from '../models/editorial-tags-response-paging';
import { FinancialTransactionResponsePaging } from '../models/financial-transaction-response-paging';
import { getCompanyCategory } from '../fn/editorial/get-company-category';
import { GetCompanyCategory$Params } from '../fn/editorial/get-company-category';
import { getEditorialActivities } from '../fn/editorial/get-editorial-activities';
import { GetEditorialActivities$Params } from '../fn/editorial/get-editorial-activities';
import { getEditorialActivity } from '../fn/editorial/get-editorial-activity';
import { GetEditorialActivity$Params } from '../fn/editorial/get-editorial-activity';
import { getEditorialAmbassadorsGold } from '../fn/editorial/get-editorial-ambassadors-gold';
import { GetEditorialAmbassadorsGold$Params } from '../fn/editorial/get-editorial-ambassadors-gold';
import { getEditorialAmbassadorsGoldXlsx } from '../fn/editorial/get-editorial-ambassadors-gold-xlsx';
import { GetEditorialAmbassadorsGoldXlsx$Params } from '../fn/editorial/get-editorial-ambassadors-gold-xlsx';
import { getEditorialAmbassadorsSilver } from '../fn/editorial/get-editorial-ambassadors-silver';
import { GetEditorialAmbassadorsSilver$Params } from '../fn/editorial/get-editorial-ambassadors-silver';
import { getEditorialAmbassadorsSilverXlsx } from '../fn/editorial/get-editorial-ambassadors-silver-xlsx';
import { GetEditorialAmbassadorsSilverXlsx$Params } from '../fn/editorial/get-editorial-ambassadors-silver-xlsx';
import { getEditorialAnalyticsDashboardCategories } from '../fn/editorial/get-editorial-analytics-dashboard-categories';
import { GetEditorialAnalyticsDashboardCategories$Params } from '../fn/editorial/get-editorial-analytics-dashboard-categories';
import { getEditorialAnalyticsDashboardViewer } from '../fn/editorial/get-editorial-analytics-dashboard-viewer';
import { GetEditorialAnalyticsDashboardViewer$Params } from '../fn/editorial/get-editorial-analytics-dashboard-viewer';
import { getEditorialAnalyticsResume } from '../fn/editorial/get-editorial-analytics-resume';
import { GetEditorialAnalyticsResume$Params } from '../fn/editorial/get-editorial-analytics-resume';
import { getEditorialAnalyticsTrafficPerPost } from '../fn/editorial/get-editorial-analytics-traffic-per-post';
import { GetEditorialAnalyticsTrafficPerPost$Params } from '../fn/editorial/get-editorial-analytics-traffic-per-post';
import { getEditorialCompanies } from '../fn/editorial/get-editorial-companies';
import { GetEditorialCompanies$Params } from '../fn/editorial/get-editorial-companies';
import { getEditorialCompaniesXlsx } from '../fn/editorial/get-editorial-companies-xlsx';
import { GetEditorialCompaniesXlsx$Params } from '../fn/editorial/get-editorial-companies-xlsx';
import { getEditorialCompany } from '../fn/editorial/get-editorial-company';
import { GetEditorialCompany$Params } from '../fn/editorial/get-editorial-company';
import { getEditorialCompanyByInvitationCode } from '../fn/editorial/get-editorial-company-by-invitation-code';
import { GetEditorialCompanyByInvitationCode$Params } from '../fn/editorial/get-editorial-company-by-invitation-code';
import { getEditorialCompanyCategories } from '../fn/editorial/get-editorial-company-categories';
import { GetEditorialCompanyCategories$Params } from '../fn/editorial/get-editorial-company-categories';
import { getEditorialCompanyCategoriesLanguages } from '../fn/editorial/get-editorial-company-categories-languages';
import { GetEditorialCompanyCategoriesLanguages$Params } from '../fn/editorial/get-editorial-company-categories-languages';
import { getEditorialCompanyDiscount } from '../fn/editorial/get-editorial-company-discount';
import { GetEditorialCompanyDiscount$Params } from '../fn/editorial/get-editorial-company-discount';
import { getEditorialCompanyDiscounts } from '../fn/editorial/get-editorial-company-discounts';
import { GetEditorialCompanyDiscounts$Params } from '../fn/editorial/get-editorial-company-discounts';
import { getEditorialCouponRequest } from '../fn/editorial/get-editorial-coupon-request';
import { GetEditorialCouponRequest$Params } from '../fn/editorial/get-editorial-coupon-request';
import { getEditorialCouponRequests } from '../fn/editorial/get-editorial-coupon-requests';
import { GetEditorialCouponRequests$Params } from '../fn/editorial/get-editorial-coupon-requests';
import { getEditorialCouponRequestsXlsx } from '../fn/editorial/get-editorial-coupon-requests-xlsx';
import { GetEditorialCouponRequestsXlsx$Params } from '../fn/editorial/get-editorial-coupon-requests-xlsx';
import { getEditorialPostCategories } from '../fn/editorial/get-editorial-post-categories';
import { GetEditorialPostCategories$Params } from '../fn/editorial/get-editorial-post-categories';
import { getEditorialPostCategoriesLanguages } from '../fn/editorial/get-editorial-post-categories-languages';
import { GetEditorialPostCategoriesLanguages$Params } from '../fn/editorial/get-editorial-post-categories-languages';
import { getEditorialReviewers } from '../fn/editorial/get-editorial-reviewers';
import { GetEditorialReviewers$Params } from '../fn/editorial/get-editorial-reviewers';
import { getEditorialTag } from '../fn/editorial/get-editorial-tag';
import { GetEditorialTag$Params } from '../fn/editorial/get-editorial-tag';
import { getEditorialTagLanguages } from '../fn/editorial/get-editorial-tag-languages';
import { GetEditorialTagLanguages$Params } from '../fn/editorial/get-editorial-tag-languages';
import { getEditorialTags } from '../fn/editorial/get-editorial-tags';
import { GetEditorialTags$Params } from '../fn/editorial/get-editorial-tags';
import { getEditorialTagsPaginated } from '../fn/editorial/get-editorial-tags-paginated';
import { GetEditorialTagsPaginated$Params } from '../fn/editorial/get-editorial-tags-paginated';
import { getFinancialTransactions } from '../fn/editorial/get-financial-transactions';
import { GetFinancialTransactions$Params } from '../fn/editorial/get-financial-transactions';
import { getFinancialTransactionsXlsx } from '../fn/editorial/get-financial-transactions-xlsx';
import { GetFinancialTransactionsXlsx$Params } from '../fn/editorial/get-financial-transactions-xlsx';
import { getLatestPostsApproved } from '../fn/editorial/get-latest-posts-approved';
import { GetLatestPostsApproved$Params } from '../fn/editorial/get-latest-posts-approved';
import { getLatestPostsToApprove } from '../fn/editorial/get-latest-posts-to-approve';
import { GetLatestPostsToApprove$Params } from '../fn/editorial/get-latest-posts-to-approve';
import { getLatestSubscribers } from '../fn/editorial/get-latest-subscribers';
import { GetLatestSubscribers$Params } from '../fn/editorial/get-latest-subscribers';
import { getPostCategoryDetail } from '../fn/editorial/get-post-category-detail';
import { GetPostCategoryDetail$Params } from '../fn/editorial/get-post-category-detail';
import { getUserAdmin } from '../fn/editorial/get-user-admin';
import { GetUserAdmin$Params } from '../fn/editorial/get-user-admin';
import { getUserAdmins } from '../fn/editorial/get-user-admins';
import { GetUserAdmins$Params } from '../fn/editorial/get-user-admins';
import { getUserPermissions } from '../fn/editorial/get-user-permissions';
import { GetUserPermissions$Params } from '../fn/editorial/get-user-permissions';
import { isEmailAvailable } from '../fn/editorial/is-email-available';
import { IsEmailAvailable$Params } from '../fn/editorial/is-email-available';
import { LatestPostsApprovedDto } from '../models/latest-posts-approved-dto';
import { LatestPostsToApproveDto } from '../models/latest-posts-to-approve-dto';
import { LatestSubscribersDto } from '../models/latest-subscribers-dto';
import { markBankTransferTransactionPaid } from '../fn/editorial/mark-bank-transfer-transaction-paid';
import { MarkBankTransferTransactionPaid$Params } from '../fn/editorial/mark-bank-transfer-transaction-paid';
import { PostCategoryLanguagesResponse } from '../models/post-category-languages-response';
import { PostCategoryResponsePaging } from '../models/post-category-response-paging';
import { publishActivity } from '../fn/editorial/publish-activity';
import { PublishActivity$Params } from '../fn/editorial/publish-activity';
import { rejectActivity } from '../fn/editorial/reject-activity';
import { RejectActivity$Params } from '../fn/editorial/reject-activity';
import { unBanEditorialUser } from '../fn/editorial/un-ban-editorial-user';
import { UnBanEditorialUser$Params } from '../fn/editorial/un-ban-editorial-user';
import { updateCompanyCategory } from '../fn/editorial/update-company-category';
import { UpdateCompanyCategory$Params } from '../fn/editorial/update-company-category';
import { updateEditorialCompany } from '../fn/editorial/update-editorial-company';
import { UpdateEditorialCompany$Params } from '../fn/editorial/update-editorial-company';
import { updateEditorialCompanyDiscount } from '../fn/editorial/update-editorial-company-discount';
import { UpdateEditorialCompanyDiscount$Params } from '../fn/editorial/update-editorial-company-discount';
import { updateEditorialCouponRequest } from '../fn/editorial/update-editorial-coupon-request';
import { UpdateEditorialCouponRequest$Params } from '../fn/editorial/update-editorial-coupon-request';
import { updateEditorialTag } from '../fn/editorial/update-editorial-tag';
import { UpdateEditorialTag$Params } from '../fn/editorial/update-editorial-tag';
import { updatePostCategory } from '../fn/editorial/update-post-category';
import { UpdatePostCategory$Params } from '../fn/editorial/update-post-category';
import { updateUserAdmin } from '../fn/editorial/update-user-admin';
import { UpdateUserAdmin$Params } from '../fn/editorial/update-user-admin';
import { updateUserPermissions } from '../fn/editorial/update-user-permissions';
import { UpdateUserPermissions$Params } from '../fn/editorial/update-user-permissions';
import { UserAdminResponse } from '../models/user-admin-response';
import { UserAdminResponsePaging } from '../models/user-admin-response-paging';
import { validateCoupon } from '../fn/editorial/validate-coupon';
import { ValidateCoupon$Params } from '../fn/editorial/validate-coupon';

@Injectable({ providedIn: 'root' })
export class EditorialService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `banEditorialUser()` */
  static readonly BanEditorialUserPath = '/api/editorial/user-admins/{userId}/ban';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `banEditorialUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  banEditorialUser$Response(params: BanEditorialUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return banEditorialUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `banEditorialUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  banEditorialUser(params: BanEditorialUser$Params, context?: HttpContext): Observable<void> {
    return this.banEditorialUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserAdmin()` */
  static readonly GetUserAdminPath = '/api/editorial/user-admins/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAdmin$Response(params: GetUserAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAdminResponse>> {
    return getUserAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAdmin(params: GetUserAdmin$Params, context?: HttpContext): Observable<UserAdminResponse> {
    return this.getUserAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAdminResponse>): UserAdminResponse => r.body)
    );
  }

  /** Path part for operation `deleteUserAdmin()` */
  static readonly DeleteUserAdminPath = '/api/editorial/user-admins/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUserAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserAdmin$Response(params: DeleteUserAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUserAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUserAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserAdmin(params: DeleteUserAdmin$Params, context?: HttpContext): Observable<void> {
    return this.deleteUserAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserAdmins()` */
  static readonly GetUserAdminsPath = '/api/editorial/user-admins';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAdmins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAdmins$Response(params: GetUserAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAdminResponsePaging>> {
    return getUserAdmins(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAdmins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAdmins(params: GetUserAdmins$Params, context?: HttpContext): Observable<UserAdminResponsePaging> {
    return this.getUserAdmins$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAdminResponsePaging>): UserAdminResponsePaging => r.body)
    );
  }

  /** Path part for operation `getUserPermissions()` */
  static readonly GetUserPermissionsPath = '/api/editorial/user-admins/{userId}/permissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserPermissions$Response(params: GetUserPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getUserPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserPermissions(params: GetUserPermissions$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getUserPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `updateUserPermissions()` */
  static readonly UpdateUserPermissionsPath = '/api/editorial/user-admins/{userId}/permissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPermissions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPermissions$Response(params: UpdateUserPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUserPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPermissions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPermissions(params: UpdateUserPermissions$Params, context?: HttpContext): Observable<void> {
    return this.updateUserPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `isEmailAvailable()` */
  static readonly IsEmailAvailablePath = '/api/editorial/user-admins/{userId}/email-available';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isEmailAvailable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  isEmailAvailable$Response(params: IsEmailAvailable$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return isEmailAvailable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `isEmailAvailable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  isEmailAvailable(params: IsEmailAvailable$Params, context?: HttpContext): Observable<boolean> {
    return this.isEmailAvailable$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `unBanEditorialUser()` */
  static readonly UnBanEditorialUserPath = '/api/editorial/user-admins/{userId}/unban';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unBanEditorialUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  unBanEditorialUser$Response(params: UnBanEditorialUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unBanEditorialUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unBanEditorialUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unBanEditorialUser(params: UnBanEditorialUser$Params, context?: HttpContext): Observable<void> {
    return this.unBanEditorialUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserAdmin()` */
  static readonly UpdateUserAdminPath = '/api/editorial/user-admins/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserAdmin$Response(params: UpdateUserAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAdminResponse>> {
    return updateUserAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserAdmin(params: UpdateUserAdmin$Params, context?: HttpContext): Observable<UserAdminResponse> {
    return this.updateUserAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAdminResponse>): UserAdminResponse => r.body)
    );
  }

  /** Path part for operation `createEditorialTags()` */
  static readonly CreateEditorialTagsPath = '/api/editorial/tags/bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEditorialTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEditorialTags$Response(params: CreateEditorialTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createEditorialTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEditorialTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEditorialTags(params: CreateEditorialTags$Params, context?: HttpContext): Observable<void> {
    return this.createEditorialTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialTag()` */
  static readonly GetEditorialTagPath = '/api/editorial/tags/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialTag$Response(params: GetEditorialTag$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialTagResponse>> {
    return getEditorialTag(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialTag(params: GetEditorialTag$Params, context?: HttpContext): Observable<EditorialTagResponse> {
    return this.getEditorialTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialTagResponse>): EditorialTagResponse => r.body)
    );
  }

  /** Path part for operation `updateEditorialTag()` */
  static readonly UpdateEditorialTagPath = '/api/editorial/tags/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEditorialTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialTag$Response(params: UpdateEditorialTag$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEditorialTag(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEditorialTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialTag(params: UpdateEditorialTag$Params, context?: HttpContext): Observable<void> {
    return this.updateEditorialTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteEditorialTag()` */
  static readonly DeleteEditorialTagPath = '/api/editorial/tags/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEditorialTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialTag$Response(params: DeleteEditorialTag$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEditorialTag(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEditorialTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialTag(params: DeleteEditorialTag$Params, context?: HttpContext): Observable<void> {
    return this.deleteEditorialTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialTagLanguages()` */
  static readonly GetEditorialTagLanguagesPath = '/api/editorial/tags-languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialTagLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialTagLanguages$Response(params?: GetEditorialTagLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorialTagLanguagesResponse>>> {
    return getEditorialTagLanguages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialTagLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialTagLanguages(params?: GetEditorialTagLanguages$Params, context?: HttpContext): Observable<Array<EditorialTagLanguagesResponse>> {
    return this.getEditorialTagLanguages$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EditorialTagLanguagesResponse>>): Array<EditorialTagLanguagesResponse> => r.body)
    );
  }

  /** Path part for operation `getEditorialTags()` */
  static readonly GetEditorialTagsPath = '/api/editorial/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialTags$Response(params: GetEditorialTags$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialTagsResponsePaging>> {
    return getEditorialTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialTags(params: GetEditorialTags$Params, context?: HttpContext): Observable<EditorialTagsResponsePaging> {
    return this.getEditorialTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialTagsResponsePaging>): EditorialTagsResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialTagsPaginated()` */
  static readonly GetEditorialTagsPaginatedPath = '/api/editorial/tags/paginated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialTagsPaginated()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEditorialTagsPaginated$Response(params: GetEditorialTagsPaginated$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorialTagsPaginatedResponse>>> {
    return getEditorialTagsPaginated(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialTagsPaginated$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getEditorialTagsPaginated(params: GetEditorialTagsPaginated$Params, context?: HttpContext): Observable<Array<EditorialTagsPaginatedResponse>> {
    return this.getEditorialTagsPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EditorialTagsPaginatedResponse>>): Array<EditorialTagsPaginatedResponse> => r.body)
    );
  }

  /** Path part for operation `getLatestPostsApproved()` */
  static readonly GetLatestPostsApprovedPath = '/api/editorial/latest-posts-approved';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLatestPostsApproved()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLatestPostsApproved$Response(params?: GetLatestPostsApproved$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LatestPostsApprovedDto>>> {
    return getLatestPostsApproved(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLatestPostsApproved$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLatestPostsApproved(params?: GetLatestPostsApproved$Params, context?: HttpContext): Observable<Array<LatestPostsApprovedDto>> {
    return this.getLatestPostsApproved$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LatestPostsApprovedDto>>): Array<LatestPostsApprovedDto> => r.body)
    );
  }

  /** Path part for operation `getLatestPostsToApprove()` */
  static readonly GetLatestPostsToApprovePath = '/api/editorial/latest-posts-to-approve';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLatestPostsToApprove()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLatestPostsToApprove$Response(params?: GetLatestPostsToApprove$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LatestPostsToApproveDto>>> {
    return getLatestPostsToApprove(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLatestPostsToApprove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLatestPostsToApprove(params?: GetLatestPostsToApprove$Params, context?: HttpContext): Observable<Array<LatestPostsToApproveDto>> {
    return this.getLatestPostsToApprove$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LatestPostsToApproveDto>>): Array<LatestPostsToApproveDto> => r.body)
    );
  }

  /** Path part for operation `getLatestSubscribers()` */
  static readonly GetLatestSubscribersPath = '/api/editorial/latest-subscribers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLatestSubscribers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLatestSubscribers$Response(params?: GetLatestSubscribers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LatestSubscribersDto>>> {
    return getLatestSubscribers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLatestSubscribers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLatestSubscribers(params?: GetLatestSubscribers$Params, context?: HttpContext): Observable<Array<LatestSubscribersDto>> {
    return this.getLatestSubscribers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LatestSubscribersDto>>): Array<LatestSubscribersDto> => r.body)
    );
  }

  /** Path part for operation `getEditorialCouponRequest()` */
  static readonly GetEditorialCouponRequestPath = '/api/editorial/company-coupon-requests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCouponRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCouponRequest$Response(params: GetEditorialCouponRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCouponResponse>> {
    return getEditorialCouponRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCouponRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCouponRequest(params: GetEditorialCouponRequest$Params, context?: HttpContext): Observable<EditorialCouponResponse> {
    return this.getEditorialCouponRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCouponResponse>): EditorialCouponResponse => r.body)
    );
  }

  /** Path part for operation `updateEditorialCouponRequest()` */
  static readonly UpdateEditorialCouponRequestPath = '/api/editorial/company-coupon-requests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEditorialCouponRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialCouponRequest$Response(params: UpdateEditorialCouponRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEditorialCouponRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEditorialCouponRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialCouponRequest(params: UpdateEditorialCouponRequest$Params, context?: HttpContext): Observable<void> {
    return this.updateEditorialCouponRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteEditorialCouponRequest()` */
  static readonly DeleteEditorialCouponRequestPath = '/api/editorial/company-coupon-requests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEditorialCouponRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialCouponRequest$Response(params: DeleteEditorialCouponRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEditorialCouponRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEditorialCouponRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialCouponRequest(params: DeleteEditorialCouponRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteEditorialCouponRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialCouponRequests()` */
  static readonly GetEditorialCouponRequestsPath = '/api/editorial/company-coupon-requests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCouponRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCouponRequests$Response(params: GetEditorialCouponRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCouponResponsePaging>> {
    return getEditorialCouponRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCouponRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCouponRequests(params: GetEditorialCouponRequests$Params, context?: HttpContext): Observable<EditorialCouponResponsePaging> {
    return this.getEditorialCouponRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCouponResponsePaging>): EditorialCouponResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialCouponRequestsXlsx()` */
  static readonly GetEditorialCouponRequestsXlsxPath = '/api/editorial/company-coupon-requests/xlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCouponRequestsXlsx()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCouponRequestsXlsx$Response(params?: GetEditorialCouponRequestsXlsx$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getEditorialCouponRequestsXlsx(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCouponRequestsXlsx$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCouponRequestsXlsx(params?: GetEditorialCouponRequestsXlsx$Params, context?: HttpContext): Observable<Blob> {
    return this.getEditorialCouponRequestsXlsx$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `validateCoupon()` */
  static readonly ValidateCouponPath = '/api/coupons/validate/{couponId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateCoupon()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateCoupon$Response(params: ValidateCoupon$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return validateCoupon(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateCoupon$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateCoupon(params: ValidateCoupon$Params, context?: HttpContext): Observable<number> {
    return this.validateCoupon$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getEditorialCompanies()` */
  static readonly GetEditorialCompaniesPath = '/api/editorial/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanies$Response(params: GetEditorialCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompaniesResponsePaging>> {
    return getEditorialCompanies(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanies(params: GetEditorialCompanies$Params, context?: HttpContext): Observable<EditorialCompaniesResponsePaging> {
    return this.getEditorialCompanies$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCompaniesResponsePaging>): EditorialCompaniesResponsePaging => r.body)
    );
  }

  /** Path part for operation `createEditorialCompany()` */
  static readonly CreateEditorialCompanyPath = '/api/editorial/companies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEditorialCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEditorialCompany$Response(params: CreateEditorialCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return createEditorialCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEditorialCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEditorialCompany(params: CreateEditorialCompany$Params, context?: HttpContext): Observable<number> {
    return this.createEditorialCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getEditorialCompanyDiscounts()` */
  static readonly GetEditorialCompanyDiscountsPath = '/api/editorial/companies/{id}/discounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompanyDiscounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyDiscounts$Response(params: GetEditorialCompanyDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyDiscountResponsePaging>> {
    return getEditorialCompanyDiscounts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompanyDiscounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyDiscounts(params: GetEditorialCompanyDiscounts$Params, context?: HttpContext): Observable<EditorialCompanyDiscountResponsePaging> {
    return this.getEditorialCompanyDiscounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCompanyDiscountResponsePaging>): EditorialCompanyDiscountResponsePaging => r.body)
    );
  }

  /** Path part for operation `createEditorialCompanyDiscount()` */
  static readonly CreateEditorialCompanyDiscountPath = '/api/editorial/companies/{id}/discounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEditorialCompanyDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEditorialCompanyDiscount$Response(params: CreateEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createEditorialCompanyDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEditorialCompanyDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEditorialCompanyDiscount(params: CreateEditorialCompanyDiscount$Params, context?: HttpContext): Observable<void> {
    return this.createEditorialCompanyDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialCompany()` */
  static readonly GetEditorialCompanyPath = '/api/editorial/companies/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompany$Response(params: GetEditorialCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyResponse>> {
    return getEditorialCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompany(params: GetEditorialCompany$Params, context?: HttpContext): Observable<EditorialCompanyResponse> {
    return this.getEditorialCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCompanyResponse>): EditorialCompanyResponse => r.body)
    );
  }

  /** Path part for operation `updateEditorialCompany()` */
  static readonly UpdateEditorialCompanyPath = '/api/editorial/companies/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEditorialCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialCompany$Response(params: UpdateEditorialCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyResponse>> {
    return updateEditorialCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEditorialCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialCompany(params: UpdateEditorialCompany$Params, context?: HttpContext): Observable<EditorialCompanyResponse> {
    return this.updateEditorialCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCompanyResponse>): EditorialCompanyResponse => r.body)
    );
  }

  /** Path part for operation `deleteEditorialCompany()` */
  static readonly DeleteEditorialCompanyPath = '/api/editorial/companies/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEditorialCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialCompany$Response(params: DeleteEditorialCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEditorialCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEditorialCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialCompany(params: DeleteEditorialCompany$Params, context?: HttpContext): Observable<void> {
    return this.deleteEditorialCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialCompanyDiscount()` */
  static readonly GetEditorialCompanyDiscountPath = '/api/editorial/companies/{companyId}/discounts/{discountId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompanyDiscount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyDiscount$Response(params: GetEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyDiscountResponse>> {
    return getEditorialCompanyDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompanyDiscount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyDiscount(params: GetEditorialCompanyDiscount$Params, context?: HttpContext): Observable<EditorialCompanyDiscountResponse> {
    return this.getEditorialCompanyDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCompanyDiscountResponse>): EditorialCompanyDiscountResponse => r.body)
    );
  }

  /** Path part for operation `updateEditorialCompanyDiscount()` */
  static readonly UpdateEditorialCompanyDiscountPath = '/api/editorial/companies/{companyId}/discounts/{discountId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEditorialCompanyDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialCompanyDiscount$Response(params: UpdateEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEditorialCompanyDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEditorialCompanyDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEditorialCompanyDiscount(params: UpdateEditorialCompanyDiscount$Params, context?: HttpContext): Observable<void> {
    return this.updateEditorialCompanyDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteEditorialCompanyDiscount()` */
  static readonly DeleteEditorialCompanyDiscountPath = '/api/editorial/companies/{companyId}/discounts/{discountId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEditorialCompanyDiscount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialCompanyDiscount$Response(params: DeleteEditorialCompanyDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEditorialCompanyDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEditorialCompanyDiscount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEditorialCompanyDiscount(params: DeleteEditorialCompanyDiscount$Params, context?: HttpContext): Observable<void> {
    return this.deleteEditorialCompanyDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialCompanyByInvitationCode()` */
  static readonly GetEditorialCompanyByInvitationCodePath = '/api/editorial/companies/invitationCode/{invitationCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompanyByInvitationCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyByInvitationCode$Response(params: GetEditorialCompanyByInvitationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyResponse>> {
    return getEditorialCompanyByInvitationCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompanyByInvitationCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyByInvitationCode(params: GetEditorialCompanyByInvitationCode$Params, context?: HttpContext): Observable<EditorialCompanyResponse> {
    return this.getEditorialCompanyByInvitationCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialCompanyResponse>): EditorialCompanyResponse => r.body)
    );
  }

  /** Path part for operation `getEditorialAnalyticsDashboardCategories()` */
  static readonly GetEditorialAnalyticsDashboardCategoriesPath = '/api/editorial/analytics/dashboard-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAnalyticsDashboardCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsDashboardCategories$Response(params?: GetEditorialAnalyticsDashboardCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsDashboardCategoriesResponse>> {
    return getEditorialAnalyticsDashboardCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAnalyticsDashboardCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsDashboardCategories(params?: GetEditorialAnalyticsDashboardCategories$Params, context?: HttpContext): Observable<EditorialAnalyticsDashboardCategoriesResponse> {
    return this.getEditorialAnalyticsDashboardCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialAnalyticsDashboardCategoriesResponse>): EditorialAnalyticsDashboardCategoriesResponse => r.body)
    );
  }

  /** Path part for operation `getEditorialAnalyticsDashboardViewer()` */
  static readonly GetEditorialAnalyticsDashboardViewerPath = '/api/editorial/analytics/dashboard-viewer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAnalyticsDashboardViewer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsDashboardViewer$Response(params?: GetEditorialAnalyticsDashboardViewer$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsDashboardViewerResponse>> {
    return getEditorialAnalyticsDashboardViewer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAnalyticsDashboardViewer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsDashboardViewer(params?: GetEditorialAnalyticsDashboardViewer$Params, context?: HttpContext): Observable<EditorialAnalyticsDashboardViewerResponse> {
    return this.getEditorialAnalyticsDashboardViewer$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialAnalyticsDashboardViewerResponse>): EditorialAnalyticsDashboardViewerResponse => r.body)
    );
  }

  /** Path part for operation `getEditorialAnalyticsResume()` */
  static readonly GetEditorialAnalyticsResumePath = '/api/editorial/analytics/analytics-resume';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAnalyticsResume()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsResume$Response(params?: GetEditorialAnalyticsResume$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsResumeResponse>> {
    return getEditorialAnalyticsResume(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAnalyticsResume$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsResume(params?: GetEditorialAnalyticsResume$Params, context?: HttpContext): Observable<EditorialAnalyticsResumeResponse> {
    return this.getEditorialAnalyticsResume$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialAnalyticsResumeResponse>): EditorialAnalyticsResumeResponse => r.body)
    );
  }

  /** Path part for operation `getEditorialAnalyticsTrafficPerPost()` */
  static readonly GetEditorialAnalyticsTrafficPerPostPath = '/api/editorial/analytics/traffic-per-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAnalyticsTrafficPerPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsTrafficPerPost$Response(params?: GetEditorialAnalyticsTrafficPerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsTrafficPerPostResponse>> {
    return getEditorialAnalyticsTrafficPerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAnalyticsTrafficPerPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAnalyticsTrafficPerPost(params?: GetEditorialAnalyticsTrafficPerPost$Params, context?: HttpContext): Observable<EditorialAnalyticsTrafficPerPostResponse> {
    return this.getEditorialAnalyticsTrafficPerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialAnalyticsTrafficPerPostResponse>): EditorialAnalyticsTrafficPerPostResponse => r.body)
    );
  }

  /** Path part for operation `getEditorialAmbassadorsGold()` */
  static readonly GetEditorialAmbassadorsGoldPath = '/api/editorial/ambassadors/gold';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAmbassadorsGold()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsGold$Response(params: GetEditorialAmbassadorsGold$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAmbassadorGoldResponsePaging>> {
    return getEditorialAmbassadorsGold(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAmbassadorsGold$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsGold(params: GetEditorialAmbassadorsGold$Params, context?: HttpContext): Observable<EditorialAmbassadorGoldResponsePaging> {
    return this.getEditorialAmbassadorsGold$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialAmbassadorGoldResponsePaging>): EditorialAmbassadorGoldResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialAmbassadorsGoldXlsx()` */
  static readonly GetEditorialAmbassadorsGoldXlsxPath = '/api/editorial/ambassadors/gold/xlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAmbassadorsGoldXlsx()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsGoldXlsx$Response(params?: GetEditorialAmbassadorsGoldXlsx$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getEditorialAmbassadorsGoldXlsx(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAmbassadorsGoldXlsx$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsGoldXlsx(params?: GetEditorialAmbassadorsGoldXlsx$Params, context?: HttpContext): Observable<Blob> {
    return this.getEditorialAmbassadorsGoldXlsx$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getEditorialAmbassadorsSilver()` */
  static readonly GetEditorialAmbassadorsSilverPath = '/api/editorial/ambassadors/silver';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAmbassadorsSilver()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsSilver$Response(params: GetEditorialAmbassadorsSilver$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAmbassadorSilverResponsePaging>> {
    return getEditorialAmbassadorsSilver(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAmbassadorsSilver$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsSilver(params: GetEditorialAmbassadorsSilver$Params, context?: HttpContext): Observable<EditorialAmbassadorSilverResponsePaging> {
    return this.getEditorialAmbassadorsSilver$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialAmbassadorSilverResponsePaging>): EditorialAmbassadorSilverResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialAmbassadorsSilverXlsx()` */
  static readonly GetEditorialAmbassadorsSilverXlsxPath = '/api/editorial/ambassadors/silver/xlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialAmbassadorsSilverXlsx()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsSilverXlsx$Response(params?: GetEditorialAmbassadorsSilverXlsx$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getEditorialAmbassadorsSilverXlsx(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialAmbassadorsSilverXlsx$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialAmbassadorsSilverXlsx(params?: GetEditorialAmbassadorsSilverXlsx$Params, context?: HttpContext): Observable<Blob> {
    return this.getEditorialAmbassadorsSilverXlsx$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `assignEditorialReviewerToActivity()` */
  static readonly AssignEditorialReviewerToActivityPath = '/api/editorial/activities/{activityId}/assign-reviewer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignEditorialReviewerToActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignEditorialReviewerToActivity$Response(params: AssignEditorialReviewerToActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignEditorialReviewerToActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignEditorialReviewerToActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignEditorialReviewerToActivity(params: AssignEditorialReviewerToActivity$Params, context?: HttpContext): Observable<void> {
    return this.assignEditorialReviewerToActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createCompanyCategory()` */
  static readonly CreateCompanyCategoryPath = '/api/editorial/company-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCompanyCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCompanyCategory$Response(params: CreateCompanyCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCompanyCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCompanyCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCompanyCategory(params: CreateCompanyCategory$Params, context?: HttpContext): Observable<void> {
    return this.createCompanyCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createPostCategory()` */
  static readonly CreatePostCategoryPath = '/api/editorial/post-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPostCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPostCategory$Response(params: CreatePostCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createPostCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPostCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPostCategory(params: CreatePostCategory$Params, context?: HttpContext): Observable<void> {
    return this.createPostCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCompanyCategory()` */
  static readonly GetCompanyCategoryPath = '/api/editorial/company-category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyCategory$Response(params: GetCompanyCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyCategoryResponse>> {
    return getCompanyCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyCategory(params: GetCompanyCategory$Params, context?: HttpContext): Observable<CompanyCategoryResponse> {
    return this.getCompanyCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyCategoryResponse>): CompanyCategoryResponse => r.body)
    );
  }

  /** Path part for operation `updateCompanyCategory()` */
  static readonly UpdateCompanyCategoryPath = '/api/editorial/company-category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyCategory$Response(params: UpdateCompanyCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCompanyCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyCategory(params: UpdateCompanyCategory$Params, context?: HttpContext): Observable<void> {
    return this.updateCompanyCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEditorialActivities()` */
  static readonly GetEditorialActivitiesPath = '/api/editorial/activities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialActivities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialActivities$Response(params: GetEditorialActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialActivityResponsePaging>> {
    return getEditorialActivities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialActivities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialActivities(params: GetEditorialActivities$Params, context?: HttpContext): Observable<EditorialActivityResponsePaging> {
    return this.getEditorialActivities$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialActivityResponsePaging>): EditorialActivityResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialActivity()` */
  static readonly GetEditorialActivityPath = '/api/editorial/activities/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialActivity$Response(params: GetEditorialActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialActivityDetailResponse>> {
    return getEditorialActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialActivity(params: GetEditorialActivity$Params, context?: HttpContext): Observable<EditorialActivityDetailResponse> {
    return this.getEditorialActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialActivityDetailResponse>): EditorialActivityDetailResponse => r.body)
    );
  }

  /** Path part for operation `getEditorialCompaniesXlsx()` */
  static readonly GetEditorialCompaniesXlsxPath = '/api/editorial/companies/xlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompaniesXlsx()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompaniesXlsx$Response(params?: GetEditorialCompaniesXlsx$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getEditorialCompaniesXlsx(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompaniesXlsx$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompaniesXlsx(params?: GetEditorialCompaniesXlsx$Params, context?: HttpContext): Observable<Blob> {
    return this.getEditorialCompaniesXlsx$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getEditorialCompanyCategories()` */
  static readonly GetEditorialCompanyCategoriesPath = '/api/editorial/company-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompanyCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyCategories$Response(params: GetEditorialCompanyCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyCategoriesResponsePaging>> {
    return getEditorialCompanyCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompanyCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyCategories(params: GetEditorialCompanyCategories$Params, context?: HttpContext): Observable<CompanyCategoriesResponsePaging> {
    return this.getEditorialCompanyCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyCategoriesResponsePaging>): CompanyCategoriesResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialCompanyCategoriesLanguages()` */
  static readonly GetEditorialCompanyCategoriesLanguagesPath = '/api/editorial/company-categories-languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialCompanyCategoriesLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyCategoriesLanguages$Response(params?: GetEditorialCompanyCategoriesLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCategoryLanguagesResponse>>> {
    return getEditorialCompanyCategoriesLanguages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialCompanyCategoriesLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialCompanyCategoriesLanguages(params?: GetEditorialCompanyCategoriesLanguages$Params, context?: HttpContext): Observable<Array<CompanyCategoryLanguagesResponse>> {
    return this.getEditorialCompanyCategoriesLanguages$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CompanyCategoryLanguagesResponse>>): Array<CompanyCategoryLanguagesResponse> => r.body)
    );
  }

  /** Path part for operation `getEditorialPostCategories()` */
  static readonly GetEditorialPostCategoriesPath = '/api/editorial/post-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialPostCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialPostCategories$Response(params: GetEditorialPostCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<PostCategoryResponsePaging>> {
    return getEditorialPostCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialPostCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialPostCategories(params: GetEditorialPostCategories$Params, context?: HttpContext): Observable<PostCategoryResponsePaging> {
    return this.getEditorialPostCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<PostCategoryResponsePaging>): PostCategoryResponsePaging => r.body)
    );
  }

  /** Path part for operation `getEditorialPostCategoriesLanguages()` */
  static readonly GetEditorialPostCategoriesLanguagesPath = '/api/editorial/post-categories-languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialPostCategoriesLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialPostCategoriesLanguages$Response(params?: GetEditorialPostCategoriesLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PostCategoryLanguagesResponse>>> {
    return getEditorialPostCategoriesLanguages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialPostCategoriesLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialPostCategoriesLanguages(params?: GetEditorialPostCategoriesLanguages$Params, context?: HttpContext): Observable<Array<PostCategoryLanguagesResponse>> {
    return this.getEditorialPostCategoriesLanguages$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PostCategoryLanguagesResponse>>): Array<PostCategoryLanguagesResponse> => r.body)
    );
  }

  /** Path part for operation `getEditorialReviewers()` */
  static readonly GetEditorialReviewersPath = '/api/editorial/reviewers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEditorialReviewers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialReviewers$Response(params?: GetEditorialReviewers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorialReviewerUser>>> {
    return getEditorialReviewers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEditorialReviewers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEditorialReviewers(params?: GetEditorialReviewers$Params, context?: HttpContext): Observable<Array<EditorialReviewerUser>> {
    return this.getEditorialReviewers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EditorialReviewerUser>>): Array<EditorialReviewerUser> => r.body)
    );
  }

  /** Path part for operation `getFinancialTransactions()` */
  static readonly GetFinancialTransactionsPath = '/api/editorial/transactions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFinancialTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFinancialTransactions$Response(params: GetFinancialTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialTransactionResponsePaging>> {
    return getFinancialTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFinancialTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFinancialTransactions(params: GetFinancialTransactions$Params, context?: HttpContext): Observable<FinancialTransactionResponsePaging> {
    return this.getFinancialTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<FinancialTransactionResponsePaging>): FinancialTransactionResponsePaging => r.body)
    );
  }

  /** Path part for operation `getFinancialTransactionsXlsx()` */
  static readonly GetFinancialTransactionsXlsxPath = '/api/editorial/transactions/xlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFinancialTransactionsXlsx()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFinancialTransactionsXlsx$Response(params?: GetFinancialTransactionsXlsx$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getFinancialTransactionsXlsx(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFinancialTransactionsXlsx$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFinancialTransactionsXlsx(params?: GetFinancialTransactionsXlsx$Params, context?: HttpContext): Observable<Blob> {
    return this.getFinancialTransactionsXlsx$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getPostCategoryDetail()` */
  static readonly GetPostCategoryDetailPath = '/api/editorial/post-category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPostCategoryDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostCategoryDetail$Response(params: GetPostCategoryDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialPostCategoryResponse>> {
    return getPostCategoryDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPostCategoryDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostCategoryDetail(params: GetPostCategoryDetail$Params, context?: HttpContext): Observable<EditorialPostCategoryResponse> {
    return this.getPostCategoryDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<EditorialPostCategoryResponse>): EditorialPostCategoryResponse => r.body)
    );
  }

  /** Path part for operation `updatePostCategory()` */
  static readonly UpdatePostCategoryPath = '/api/editorial/post-category/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePostCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePostCategory$Response(params: UpdatePostCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePostCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePostCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePostCategory(params: UpdatePostCategory$Params, context?: HttpContext): Observable<void> {
    return this.updatePostCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `markBankTransferTransactionPaid()` */
  static readonly MarkBankTransferTransactionPaidPath = '/api/payment/{id}/mark-paid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markBankTransferTransactionPaid()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  markBankTransferTransactionPaid$Response(params: MarkBankTransferTransactionPaid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return markBankTransferTransactionPaid(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markBankTransferTransactionPaid$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  markBankTransferTransactionPaid(params: MarkBankTransferTransactionPaid$Params, context?: HttpContext): Observable<void> {
    return this.markBankTransferTransactionPaid$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `publishActivity()` */
  static readonly PublishActivityPath = '/api/editorial/activities/{id}/publish';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishActivity$Response(params: PublishActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return publishActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  publishActivity(params: PublishActivity$Params, context?: HttpContext): Observable<void> {
    return this.publishActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rejectActivity()` */
  static readonly RejectActivityPath = '/api/editorial/activities/{id}/reject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectActivity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rejectActivity$Response(params: RejectActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rejectActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rejectActivity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rejectActivity(params: RejectActivity$Params, context?: HttpContext): Observable<void> {
    return this.rejectActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
